"use strict";

var formValidation = require("../components/formValidation");
var createErrorNotification = require("../components/errorNotification");
var passwordShow = require("../components/passwordShow");
var passwordRequirements = require("../components/passwordRequirements");
var fieldRequirements = require("../components/fieldRequirements");
var Lightpick = require("../components/lightpick");
var checkboxesGroupValidation = require("../components/checkboxesGroupValidation");
var initializeCheckboxAccessibility = require("../components/checkboxAccessibility");
var googleRecaptcha = require("../googleRecaptcha");
var recaptchaErrorNotification = require("../components/recaptchaErrorNotification");
var setClearButtonPosition = require("../components/setClearButtonPosition");
var setEyeButtonPosition = require("../components/setEyeButtonPosition");
const ENTER_KEY = 13;
const SPACE_KEY = 32;
const LEFT_ARROW_KEY = 37;
const RIGHT_ARROW_KEY = 39;
const HOME_KEY = 36;
const END_KEY = 35;

//Initialize  Lightpick for the birthdate input
var birthdateField = document.getElementById("register_birthdate");

if (birthdateField) {
    new Lightpick({field: birthdateField});

    birthdateField.addEventListener("keyup", getBirthdate);
}

/**
 * @function
 * @description function to add "/" in the input after typing the first 2 groups of characters (if user types "24021990" to be modified to "24/02/1990")
 * in case of Babolat_JP(if user types "19960525" to be modified to "1996/05/25")
 */
function getBirthdate() {
    // Retrieve variable from SitePreferences in isml to check current site
    const isSiteJP = $(".isSiteJP").val();
    // Trigger only if current site is BabolatJP
    if (isSiteJP === "true") {
        birthdateField.value = birthdateField.value.replace(/^(\d\d\d\d)(\d)$/g, "$1/$2").replace(/^(\d\d\d\d\/\d\d)(\d+)$/g, "$1/$2").replace(/[^\d\/]/g, ""); // eslint-disable-line
    // For any other site that is not JP enter else
    } else {
        birthdateField.value = birthdateField.value.replace(/^(\d\d)(\d)$/g, "$1/$2").replace(/^(\d\d\/\d\d)(\d+)$/g, "$1/$2").replace(/[^\d\/]/g, ""); // eslint-disable-line
    }
}

module.exports = {
    login: function () {
        $("form.login").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            googleRecaptcha.getRecaptchaResponse().then(function () {
                return googleRecaptcha.getRecaptchaToken(form);
            }).then(function (token) {
                $("form.login").trigger("login:submit", e);
                var postData = form.serialize();
                if (token) {
                    postData += "&g-recaptcha-response=" + encodeURIComponent(token);
                }
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: postData,
                    success: function (data) {
                        var $formLogin = $("form.login");
                        form.spinner().stop();
                        if (!data.success) {
                            formValidation(form, data);
                            $formLogin.trigger("login:error", data);
                        } else {
                            $formLogin.trigger("login:success", data);
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $("form.login").trigger("login:error", data);
                            form.spinner().stop();
                        }
                    }
                });
            }).catch(function () {
                var errorMessageText = $("#google-recaptcha-main").data("error-login");
                form.spinner().stop();
                recaptchaErrorNotification($(".error-messaging-recaptcha"), errorMessageText);
            });
            return false;
        });
    },

    register: function () {
        $("form.registration").submit(function (e) {
            e.preventDefault();

            var checkboxValidation = checkboxesGroupValidation();
            if (!checkboxValidation) {
                var form = $(this);
                var url = form.attr("action");
                form.spinner().start();
                googleRecaptcha.getRecaptchaResponse().then(function () {
                    $("form.registration").trigger("login:register", e);

                    $.ajax({
                        url: url,
                        type: "post",
                        dataType: "json",
                        data: form.serialize(),
                        success: function (data) {
                            form.spinner().stop();
                            if (!data.success) {
                                formValidation(form, data);
                            } else {
                                location.href = data.redirectUrl;
                            }

                            setEyeButtonPosition();
                        },
                        error: function (err) {
                            if (err.responseJSON.redirectUrl) {
                                window.location.href = err.responseJSON.redirectUrl;
                            } else {
                                createErrorNotification($(".error-messaging"), err.responseJSON.errorMessage);
                            }

                            form.spinner().stop();
                        }
                    });
                }).catch(function () {
                    var errorMessageText = $("#google-recaptcha-main").data("error-register");
                    form.spinner().stop();
                    recaptchaErrorNotification($(".error-register-recaptcha"), errorMessageText);
                });
                return false;
            }
        });
    },

    resetPassword: function () {
        $(".reset-password-form").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            $(".reset-password-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(".request-password-title").text(data.receivedMsgHeading);
                        $(".request-password-body").empty()
                            .append("<p>" + data.receivedMsgBody + "</p>");
                        if (!data.mobile) {
                            $("#submitEmailButton").text(data.buttonText)
                                .attr("data-dismiss", "modal");
                        } else {
                            $(".send-email-btn").empty()
                                .html("<a href=\""
                                    + data.returnUrl
                                    + "\" class=\"btn btn-primary btn-block m-login__btn c-button c-button--primary\">"
                                    + data.buttonText + "</a>"
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    trackOrder: function () {
        $(".track-order-form").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            form.spinner().start();
            googleRecaptcha.getRecaptchaResponse().then(function () {
                $.ajax({
                    url: form.attr("action"),
                    type: "post",
                    data: form.serialize(),
                    success: function (response) {
                        form.spinner().stop();
                        $("body").html(response);
                    },
                    error: function (response) {
                        form.spinner().stop();
                        $("body").html(response);
                    }
                });
            }).catch(function () {
                var errorMessageText = $("#google-recaptcha-main").data("error-order-status");
                form.spinner().stop();
                recaptchaErrorNotification($(".error-order-status-recaptcha"), errorMessageText);
            });
        });
    },

    clearResetForm: function () {
        $("#login .modal").on("hidden.bs.modal", function () {
            $("#reset-password-email").val("");
            $(".modal-dialog .form-control.is-invalid").removeClass("is-invalid");
        });
    },

    changePhoneData: function () {
        var country = $("select[name$=_countryCode]");

        country.on("change", function () {
            var $this = $(this);
            var form = $this.parents("form")[0];
            var inputValue = $this.val();
            var url = $(".phonePrefix", form).attr("data-url") + "?countryCode=" + inputValue;

            $.ajax({
                url: url,
                type: "get",
                success: function (data) {
                    var $phoneInputField = $("input[name$=_phone]", form);

                    $(".phonePrefix", form).val(data.prefix);
                    $phoneInputField.attr("placeholder", data.placeholder);

                    if (data.regex) {
                        $phoneInputField.attr("pattern", data.regex);
                    }
                }
            });
        });
    },

    passwordShow: passwordShow(),
    passwordRequirements: passwordRequirements(),
    fieldRequirements: fieldRequirements(),
    initializeCheckboxAccessibility: initializeCheckboxAccessibility(".m-login"),
    setClearButtonPosition: function () {
        $("input").each((i, el)=>{setClearButtonPosition(el);});

        let $targetNode = $(".tab-pane-login");

        if ($targetNode.length < 1) {
            return;
        }

        let config = { attributes: true, attributeFilter: ["class"] };
        let callback = function (mutationsList) {
            mutationsList.forEach(function (mutation) {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    $("input").each((i, el)=>{setClearButtonPosition(el);});
                }
            });
        };
        let observer = new MutationObserver(callback);

        observer.observe($targetNode[0], config);
    },
    setPasswordEyePosition: function () {
        setEyeButtonPosition();

        $("body").on("submit", "[name=change-password-form]", () =>{
            setEyeButtonPosition();
        });
    },
    initializeAccessibility: function () {
        $("body").on("keydown", "input[type=radio]+label, input[type=checkbox]+label", function (e) {
            if (e.keyCode === ENTER_KEY || e.keyCode === SPACE_KEY) {
                let inputID = $(this).attr("for");

                if (inputID && inputID.length) {
                    e.preventDefault();

                    $(`#${inputID}`).prop("checked", function (i, val) {
                        return !val;
                    }).trigger("change");
                }
            }
        });
    },
    initializeLoginTabsAccessibility: function () {
        let $tabList = $(".m-login__nav-tabs[role=tablist]");

        if (!$tabList.length) {
            return;
        }

        let tabSelector = "a[role=tab]";

        let updateTabState = function ($tabs, activeTabId) {
            $tabs.each(function () {
                let $tab = $(this);
                let isActive = $tab.attr("id") === activeTabId;

                $tab.attr("aria-selected", isActive ? "true" : "false");
                $tab.attr("tabindex", isActive ? "0" : "-1");
            });
        };

        let getActiveTabId = function ($tabs) {
            let $activeTab = $tabs.filter(".active").first();

            if ($activeTab.length) {
                return $activeTab.attr("id");
            }

            return $tabs.first().attr("id");
        };

        $tabList.each(function () {
            let $currentTabList = $(this);
            let $tabs = $currentTabList.find(tabSelector);

            if (!$tabs.length) {
                return;
            }

            updateTabState($tabs, getActiveTabId($tabs));
        });

        $("body")
            .off("shown.bs.tab.loginTabsA11y", ".m-login__nav-tabs a[role=tab]")
            .on("shown.bs.tab.loginTabsA11y", ".m-login__nav-tabs a[role=tab]", function (e) {
                let $currentTab = $(e.target);
                let $tabs = $currentTab.closest(".m-login__nav-tabs").find(tabSelector);

                updateTabState($tabs, $currentTab.attr("id"));
            });

        $("body")
            .off("keydown.loginTabsA11y", ".m-login__nav-tabs a[role=tab]")
            .on("keydown.loginTabsA11y", ".m-login__nav-tabs a[role=tab]", function (e) {
                let key = e.which || e.keyCode;

                if (key !== LEFT_ARROW_KEY && key !== RIGHT_ARROW_KEY && key !== HOME_KEY && key !== END_KEY) {
                    return;
                }

                e.preventDefault();

                let $tabs = $(this).closest(".m-login__nav-tabs").find(tabSelector);
                let currentIndex = $tabs.index(this);
                let nextIndex = currentIndex;

                if (key === RIGHT_ARROW_KEY) {
                    nextIndex = (currentIndex + 1) % $tabs.length;
                } else if (key === LEFT_ARROW_KEY) {
                    nextIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
                } else if (key === HOME_KEY) {
                    nextIndex = 0;
                } else if (key === END_KEY) {
                    nextIndex = $tabs.length - 1;
                }

                let $nextTab = $tabs.eq(nextIndex);

                if (!$nextTab.length) {
                    return;
                }

                $nextTab.tab("show");
                $nextTab.focus();
            });
    }
};
